import { createBrowserRouter } from "react-router-dom";
import { Authenticator } from "@aws-amplify/ui-react";
import Form2025 from "./pages/2025/Form";
import SPLA2025 from "./pages/2025";
import SPLA2025Zh from "./pages/2025/zh";
import SmartCity2023 from "./pages/2023";
import SmartCity2023Zh from "./pages/2023/zh";
import SmartCity2022 from "./pages/2022";
import SmartCity2022ZhIndex from "./pages/2022/zh";
import Awards2022 from "./pages/2022/awards";
import Judges2022 from "./pages/2022/judges";
import Winners2022 from "./pages/2022/winners";
import JudgesCriteria2022 from "./pages/2022/judges_criteria";
import RelatedEvents2022 from "./pages/2022/related_events";
import Highlights2022 from "./pages/2022/highlights";
import HighlightsVideo2022 from "./pages/2022/highlightsVideo";
import HighlightsArticles2022 from "./pages/2022/highlightsArticles";
import Awards2022Zh from "./pages/2022/zh/awards";
import Judges2022Zh from "./pages/2022/zh/judges";
import Winners2022Zh from "./pages/2022/zh/winners";
import JudgesCriteria2022Zh from "./pages/2022/zh/judges_criteria";
import RelatedEvents2022Zh from "./pages/2022/zh/related_events";
import Highlights2022Zh from "./pages/2022/zh/highlights";
import HighlightsVideo2022Zh from "./pages/2022/zh/highlightsVideo";
import HighlightsArticles2022Zh from "./pages/2022/zh/highlightsArticles";
import SmartCity2021 from "./pages/2021";
import Awards2021 from "./pages/2021/awards";
import Judges2021 from "./pages/2021/judges";
import Winners2021 from "./pages/2021/winners";
import Highlight2021 from "./pages/2021/highlight";
import Sponsors2021 from "./pages/2021/sponsors";
import Portfolio2021 from "./pages/2021/portfolio";
import SmartCity2018 from "./pages/2018";
import SmartCity2018Zh from "./pages/2018/zh";
import Agenda2018 from "./pages/2018/agenda";
import Agenda2018Zh from "./pages/2018/zh/agenda";
import Awards2018 from "./pages/2018/awards";
import Winners2018 from "./pages/2018/winners";
import Advisory2018 from "./pages/2018/advisory";
import Judges2018 from "./pages/2018/judges";
import JudgesCriteria2018 from "./pages/2018/judges_criteria";
import Sponsors2018 from "./pages/2018/sponsors";
import Highlights2018 from "./pages/2018/highlights";
import ContactUs2018 from "./pages/2018/contact_us";
import Awards2018Zh from "./pages/2018/zh/awards";
import Winners2018Zh from "./pages/2018/zh/winners";
import Advisory2018Zh from "./pages/2018/zh/advisory";
import Judges2018Zh from "./pages/2018/zh/judges";
import JudgesCriteria2018Zh from "./pages/2018/zh/judges_criteria";
import Sponsors2018Zh from "./pages/2018/zh/sponsors";
import Highlights2018Zh from "./pages/2018/zh/highlights";
import ContactUs2018Zh from "./pages/2018/zh/contact_us";
import BackendLayout from "../backend/BackendLayout";
import Applications from "../backend/Applications";
import Dashboard from "../backend/Dashboard";
import JudgeManagement from "../backend/JudgeManagement";
import ProtectedRoute from "../backend/ProtectedRoute";
import { USER_GROUPS } from "./services/authService";

export const router = createBrowserRouter([
  {
    path: "/",
    children: [
      // Root redirect to 2023 page first
      {
        index: true,
        element: <SPLA2025 />,
      },
      // Form routes
      {
        path: "form",
        element: <Form2025 />,
      },
      {
        path: "2025/form",
        element: <Form2025 />,
      },
      {
        path: "2023/index.php",
        element: <SmartCity2023 />,
      },
      // Historical year routes (2023-2018)
      {
        path: "2025",
        element: <SPLA2025 />,
      },
      {
        path: "2025/zh",
        element: <SPLA2025Zh />,
      },
      {
        path: "2025/zh/index.html",
        element: <SPLA2025Zh />,
      },
      {
        path: "2023",
        element: <SmartCity2023 />,
      },
      {
        path: "2023/zh",
        element: <SmartCity2023Zh />,
      },
      {
        path: "2023/index.php",
        element: <SmartCity2023 />,
      },
      {
        path: "2023/zh/index.php",
        element: <SmartCity2023Zh />,
      },
      {
        path: "2022",
        element: <SmartCity2022 />, // Will redirect to 2022 site
      },
      {
        path: "2022/index.php",
        element: <SmartCity2022 />,
      },
      {
        path: "2022/zh",
        element: <SmartCity2022ZhIndex />,
      },
      {
        path: "2022/zh/index.php",
        element: <SmartCity2022ZhIndex />,
      },
      { path: "2022/awards.php", element: <Awards2022 /> },
      { path: "2022/judges.php", element: <Judges2022 /> },
      { path: "2022/winners.php", element: <Winners2022 /> },
      { path: "2022/judges_criteria.php", element: <JudgesCriteria2022 /> },
      { path: "2022/related_events.php", element: <RelatedEvents2022 /> },
      { path: "2022/highlights.php", element: <Highlights2022 /> },
      { path: "2022/highlightsVideo.php", element: <HighlightsVideo2022 /> },
      { path: "2022/highlightsArticles.php", element: <HighlightsArticles2022 /> },
      { path: "2022/zh/awards.php", element: <Awards2022Zh /> },
      { path: "2022/zh/judges.php", element: <Judges2022Zh /> },
      { path: "2022/zh/winners.php", element: <Winners2022Zh /> },
      { path: "2022/zh/judges_criteria.php", element: <JudgesCriteria2022Zh /> },
      { path: "2022/zh/related_events.php", element: <RelatedEvents2022Zh /> },
      { path: "2022/zh/highlights.php", element: <Highlights2022Zh /> },
      { path: "2022/zh/highlightsVideo.php", element: <HighlightsVideo2022Zh /> },
      { path: "2022/zh/highlightsArticles.php", element: <HighlightsArticles2022Zh /> },
      {
        path: "2021",
        element: <SmartCity2021 />,
      },
      { path: "2021/index", element: <SmartCity2021 /> },
      { path: "2021/index.php", element: <SmartCity2021 /> },
      { path: "2021/awards", element: <Awards2021 /> },
      { path: "2021/awards.php", element: <Awards2021 /> },
      { path: "2021/judges", element: <Judges2021 /> },
      { path: "2021/judges.php", element: <Judges2021 /> },
      { path: "2021/winners", element: <Winners2021 /> },
      { path: "2021/winners.php", element: <Winners2021 /> },
      { path: "2021/highlight", element: <Highlight2021 /> },
      { path: "2021/highlight.php", element: <Highlight2021 /> },
      { path: "2021/sponsors", element: <Sponsors2021 /> },
      { path: "2021/sponsors.php", element: <Sponsors2021 /> },
      { path: "2021/portfolio", element: <Portfolio2021 /> },
      { path: "2021/portfolio.php", element: <Portfolio2021 /> },
      {
        path: "2018",
        element: <SmartCity2018 />,
      },
      { path: "2018/zh", element: <SmartCity2018Zh /> },
      { path: "2018/agenda", element: <Agenda2018 /> },
      { path: "2018/zh/agenda", element: <Agenda2018Zh /> },
      { path: "2018/awards", element: <Awards2018 /> },
      { path: "2018/winners", element: <Winners2018 /> },
      { path: "2018/advisory", element: <Advisory2018 /> },
      { path: "2018/judges", element: <Judges2018 /> },
      { path: "2018/judges_criteria", element: <JudgesCriteria2018 /> },
      { path: "2018/sponsors", element: <Sponsors2018 /> },
      { path: "2018/highlights", element: <Highlights2018 /> },
      { path: "2018/contact_us", element: <ContactUs2018 /> },
      { path: "2018/zh/awards", element: <Awards2018Zh /> },
      { path: "2018/zh/winners", element: <Winners2018Zh /> },
      { path: "2018/zh/advisory", element: <Advisory2018Zh /> },
      { path: "2018/zh/judges", element: <Judges2018Zh /> },
      { path: "2018/zh/judges_criteria", element: <JudgesCriteria2018Zh /> },
      { path: "2018/zh/sponsors", element: <Sponsors2018Zh /> },
      { path: "2018/zh/highlights", element: <Highlights2018Zh /> },
      { path: "2018/zh/contact_us", element: <ContactUs2018Zh /> },
      {
        path: "backend",
        element: (
          <Authenticator.Provider>
            <BackendLayout />
          </Authenticator.Provider>
        ),
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute allowedRoles={[USER_GROUPS.ADMIN, USER_GROUPS.SUPER_ADMIN]} redirectTo="/backend/applications">
                <Dashboard />
              </ProtectedRoute>
            ),
          },
          {
            path: "dashboard",
            element: (
              <ProtectedRoute allowedRoles={[USER_GROUPS.ADMIN, USER_GROUPS.SUPER_ADMIN]} redirectTo="/backend/applications">
                <Dashboard />
              </ProtectedRoute>
            ),
          },
          {
            path: "applications",
            element: <Applications />,
          },
          {
            path: "judge-management",
            element: (
              <ProtectedRoute allowedRoles={[USER_GROUPS.SUPER_ADMIN]} redirectTo="/backend/applications">
                <JudgeManagement />
              </ProtectedRoute>
            ),
          }
        ],
      },
      {
        path: "2025/backend",
        element: (
            <Authenticator.Provider>
              <BackendLayout />
            </Authenticator.Provider>
          ),
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute allowedRoles={[USER_GROUPS.ADMIN, USER_GROUPS.SUPER_ADMIN]} redirectTo="/backend/applications">
                <Dashboard />
              </ProtectedRoute>
            ),
          },
        ],
      },
    ],
  },
]);
